import { ExternalTransactionTypes } from '../enum/extranal-transaction-types';
import { LiliTransaction, positiveFormattedAmount, prettyTitle } from '../types/lili-transaction';

export const x = {};

export function transactionDescription(t: LiliTransaction): string {
  switch (t.externalTransactionType) {
    case ExternalTransactionTypes.SWIPE_CASHBACK:
      return `Cashback - ${t.locationDetails?.name || prettyTitle(t)}`;

    case ExternalTransactionTypes.TAX_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.TAX_BUCKET_MANUAL_SAVE:
    case ExternalTransactionTypes.EMERGENCY_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.EMERGENCY_BUCKET_MANUAL_SAVE:
      return t.trxTitle;

    case ExternalTransactionTypes.REFERRAL_GIFT:
      return `${positiveFormattedAmount(t)} Reward`;

    case ExternalTransactionTypes.CAMPAIGN_GIFT:
      return prettyTitle(t);

    case ExternalTransactionTypes.DEBIT_CARD_DEPOSIT:
    case ExternalTransactionTypes.EMERGENCY_SAVINGS_ACCOUNT_INTEREST:
    case ExternalTransactionTypes.CASH_DEPOSIT:
      return prettyTitle(t);

    case ExternalTransactionTypes.DIRECT_DEPOSIT_RETURN:
      return 'ACH Transfer return';

    case ExternalTransactionTypes.INTERNATIONAL_INCOMING_WIRE:
      return 'International Wire In';

    default:
      return t.locationDetails?.name || prettyTitle(t);
  }
}
